import * as React from "react";
import {PageWrapper} from "components/widgets/PageWrapper";
import {observer} from "mobx-react";

import './PageWrapperWithNav.pcss';
import {PageEnum} from "components/nav/PageEnums";

export interface IPageWrapperWithNav_Props {
  pageEnum:PageEnum;
  nav:any;
  className?:string;
  extra?:any;
}

@observer
export class PageWrapperWithNav extends React.Component<IPageWrapperWithNav_Props> {
  render() {
    return (
      <div className={this.props.className}>
        {this.props.nav}
        <PageWrapper static={true} {...this.props} noPadding>
          {this.props.children}
        </PageWrapper>
        {this.props.extra}
      </div>
    );
  }
}

